import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column min-vh-100" }
const _hoisted_2 = { class: "container container-fluid" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "row restaurants-list" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"card shadow-sm rounded-3 border-0 h-100\"><div class=\"w-100 loading-skeleton\" style=\"height:150px;\"></div><div class=\"card-body px-3\"><p class=\"text-success fw-bold small mb-1 loading-skeleton\"><i class=\"fas fa-circle availability\"></i> Available </p><h6 class=\"card-title fw-bold mb-1 py-2 loading-skeleton\"></h6><p class=\"text-muted py-1 loading-skeleton\"></p><a href=\"#\" class=\"btn rounded-3 w-100 fw-bold loading-skeleton\">Book Now</a></div></div>", 1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (index) => {
              return _createElementVNode("div", {
                key: index,
                class: "col-lg-3 col-md-4 col-sm-6 mb-4"
              }, _hoisted_6)
            }), 64))
          ])
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ]))
}